import { NavLink, useNavigate, useParams } from "react-router-dom"
import SecondaryBar from "../SecondaryBar"
import useLabels from "../../hooks/useLabels";
import { useEffect, useState } from "react";
import { Button, CTA } from "../Generic";
import { useDispatch, useSelector } from "react-redux";
import { selectActiveWinery,  selectAnalysis,  selectConfigs,  selectDrugs,  selectExams,  selectLots,  selectOperations,  selectTanks,  selectTreatments,  selectUser,  selectUsers, selectWineMaking } from "../../context/selectors";
import DestemmingForm from "./DestemmingForm";
import AnalysisForm from "./AnalysisForm";
import CutForm from "./CutForm";
import { setOperations } from "../../context/operations/operationsSlice";
import { getDrugs, getExams, getLots, getOperations, getProtocols, getTanks, getUsers } from "../../services/utils";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { setUsers } from "../../context/users/usersSlice";
import { setTanks } from "../../context/tanks/tanksSlice";
import { setLots } from "../../context/lots/lotsSlice";

import './styles/index.scss';
import TransferForm from "./TransferForm";
import { setAnalysis } from "../../context/protocols/analysisSlice";
import { setTreatments } from "../../context/protocols/treatmentsSlice";
import WineMakingForm from "./WineMakingForm";
import LotForm from "../LotForm";
import AutomaticForm from "./AutomaticForm";
import BottlingForm from "./BottlingForm";
import { setDrugs } from "../../context/substances/drugsSlice";
import { setExams } from "../../context/substances/examsSlice";
import { setWineMaking } from "../../context/protocols/wineMakingSlice";

const OperationsForm = ({ isDuplicate, isMobile = false}) => {

    const { id, type: rawType } = useParams();
    const type = rawType?.toUpperCase?.();
    const [getLabel] = useLabels();
    const activeWinery = useSelector(selectActiveWinery);
    const navigate = useNavigate();

    const user = useSelector(selectUser);
    const users = useSelector(selectUsers);
    const tanks = useSelector(selectTanks);
    const lots = useSelector(selectLots);
    const configs = useSelector(selectConfigs);
    const operations = useSelector(selectOperations);
    const protocols = useSelector(type === 'TREATMENT' ? selectTreatments : type === 'ANALYSIS' ? selectAnalysis : selectWineMaking);
    const wineMakingProtocols = useSelector(selectWineMaking);
    const substances = useSelector(type === 'ANALYSIS' ? selectExams : selectDrugs);

    const dispatch = useDispatch();
    const axiosPrivate = useAxiosPrivate();
    const [operation, setOperation] = useState(null);

    const loadOperations = async () => {
        const currentOperations = await getOperations(axiosPrivate);
        dispatch(setOperations(currentOperations))
    }

    const loadUsers = async () => {
        const currentUsers = await getUsers(axiosPrivate);
        dispatch(setUsers(currentUsers));
    }

    const loadTanks = async () => {
        const currentTanks = await getTanks(activeWinery.id, axiosPrivate);
        dispatch(setTanks(currentTanks));
    }

    const loadLots = async () => {
        const currentLots = await getLots(activeWinery.id, axiosPrivate);
        dispatch(setLots(currentLots));
    }

    const loadTreatments = async () => {
        const currentTreatments = await getProtocols('treatment', axiosPrivate);
        dispatch(setTreatments(currentTreatments));
    }

    const loadProtocols = async () => {
        const currentProtocols = await getProtocols('winemaking', axiosPrivate) || [];
        dispatch(setWineMaking(currentProtocols));

    }

    const loadAnalysis = async () => {
        const currentAnalysis = await getProtocols('analysis', axiosPrivate);
        dispatch(setAnalysis(currentAnalysis));
    }

    const loadSubstances = async () => {
        const currentSubstances = await (type === "TREATMENT"
        ? getDrugs(axiosPrivate)
        : getExams(axiosPrivate));
        dispatch(
        type === "TREATMENT"
            ? setDrugs(currentSubstances)
            : setExams(currentSubstances)
        );
    };
    
    const initData = async () => {
        const promiseArray = [];
        if (operations?.length === 0) {
            promiseArray.push(loadOperations())
        }
        if (users?.length === 0) {
            promiseArray.push(loadUsers())
        }
        if (tanks?.length === 0) {
            promiseArray.push(loadTanks())
        }
        if (lots?.length === 0) {
            promiseArray.push(loadLots())
        }
        if (substances?.length === 0) {
            promiseArray.push(loadSubstances())
        }
        if (protocols?.length === 0 && type === 'ANALYSIS') {
            promiseArray.push(loadAnalysis());
        } else if (protocols?.length === 0 && type === 'TREATMENT') {
            promiseArray.push(loadTreatments());
            promiseArray.push(loadProtocols());
        }

        return Promise.all(promiseArray);
    }

    useEffect(() => {
        initData();        
    }, [])

    useEffect(() => {
        if (operations && operations?.length > 0) {
            setOperation(operations.find((operationsDb) => {
                return operationsDb.id === Number(id)
            }) || null)
        }
    }, [operations])

    const renderNavMenu = () => {
        const navClickHandler = () => {
            // window.history.back()

            if (id) navigate(`/programming/${rawType}/${id}`);
            else navigate(`/programming`);
        }

        return (
            <div className="primary_container_menu">
                <div className="primary_container_row">
                    <Button
                        arrowDirection="left"
                        onClick={navClickHandler}
                    />
                    <h2>{getLabel(id && !isDuplicate  ? 'programmingUpdatePage' :  'programmingNewPageWithType', { type: getLabel(`operationType${type}`)?.toLowerCase?.()})}</h2>
                </div>
            </div>
        )
    }

    const renderOperationCase = () => {

        if (id && operation?.completion_date !== null)
            return (<div className="redirect_wrapper">
              <h5 className="alert_no_info">{getLabel("noPendingOperation")}</h5>
            <NavLink
                to={`/programming/${type?.toLowerCase?.()}/${id}`}
            >
                <CTA>
                    {getLabel('noPendingOperationToDetail')}
                </CTA>
            </NavLink>
            </div>);
            
        switch (type) {
            case 'NEW_LOT':
                return <LotForm isOnlyForm={true} operation={operation} isDuplicate={isDuplicate} />
            case 'DESTEMMING':
                return <DestemmingForm
                    type={type}
                    // lots={lots.filter((lot) => lot?.state === 'GRAPE')}
                    lots={lots}
                    // allLots={lots}
                    tanks={tanks}
                    // tanks={tanks.filter((tank) => tank?.quantity === null || tank?.quantity === 0)}
                    operation={operation}
                    users={user.role === 2 ? users?.filter((u) => u.username != user.userName && u.role_id === 3) : users}
                    configs={configs}
                    activeWinery={activeWinery}
                    isNewLot={type === 'NEW_LOT'}
                    isMobile={isMobile}
                />
            
            case 'TREATMENT':
            case 'ANALYSIS':
                return <AnalysisForm
                    type={type}
                    tanks={tanks}
                    lots={type === 'ANALYSIS' ? lots : lots?.filter((l) => l.state !== 'GRAPE')}
                    users={user.role === 2 ? users?.filter((u) => u.username != user.userName && u.role_id === 3) : users}
                    protocols={protocols}
                    wineMakingProtocols={wineMakingProtocols}
                    allSubstances={substances}
                    activeWinery={activeWinery}
                    configs={configs}
                    operation={operation}
                    operations={operations}
                />
            case 'CUT':
                return <CutForm
                    operation={operation}
                    lots={lots?.filter((lot) => lot?.state !== 'GRAPE')}
                    tanks={tanks}
                    type={type}
                    users={user.role === 2 ? users?.filter((u) => u.username != user.userName && u.role_id === 3) : users}
                    activeWinery={activeWinery}
                    configs={configs}
                />
            case 'DECANT':  // travaso
            case 'RACKING': // svinatura
            case 'FILTERING': // filtraggio
            case 'CLOSING':
                return <TransferForm
                    lots={lots}
                    tanks={tanks}
                    type={type}
                    users={user.role === 2 ? users?.filter((u) => u.username != user.userName && u.role_id === 3) : users}
                    activeWinery={activeWinery}
                    configs={configs}
                    isDuplicate={isDuplicate}
                    operation={operation}
                />
            case 'WINEMAKING':
            case 'WINEMAKINGPOST':
            case 'CLEANING':
            case 'PHYSICAL':
            case 'STABILIZATION_STATIC':
            case 'STABILIZATION_DYNAMIC':
            case 'STABILIZATION_RESIN':
                return <WineMakingForm
                    lots={lots}
                    tanks={tanks}
                    type={type}
                    users={user.role === 2 ? users?.filter((u) => u.username != user.userName && u.role_id === 3) : users}
                    activeWinery={activeWinery}
                    configs={configs}
                    operation={operation}
                />
            case 'BOTTLING':
                return <BottlingForm
                    operation={operation}
                    lots={lots}
                    tanks={tanks?.filter((t) => Number(t?.quantity) > 0 && t?.state === 'WINE')}
                    type={type}
                    users={user.role === 2 ? users?.filter((u) => u.username != user.userName && u.role_id === 3) : users}
                    activeWinery={activeWinery}
                    configs={configs}
                />

            case "ADD":
            case "ENZYME":
            case "SO2":
            case "NITROGEN": 
            case "INOCULATION":
            case "BOIS":
            case "TANNISSAGE":
            case "OXYGENATION":
            case "HOMOGENIZATION_MASS":
                return (
                <AutomaticForm
                    type={type}
                    operation={operation}
                    operations={operations}
                    users={user.role === 2 ? users?.filter((u) => u.username != user.userName && u.role_id === 3) : users}
                    tanks={tanks}
                    lots={lots}
                    substances={substances}
                    configs={configs}
                    protocols={protocols}
                    // axiosPrivate={axiosPrivate}
                />
                );
            default: 
                console.error('error case')
                return null
        }
    }

    return (<div className="primary_container">
        <div className="primary_container_top">
            <SecondaryBar
                breadCrumb={
                    (id && !isDuplicate )? [
                        { label: getLabel('programmingNavLink'), link: '/programming' },
                        getLabel(`operationType${type}`),
                        getLabel('programmingUpdatePage')
                    ] : [
                        { label: getLabel('programmingNavLink'), link: '/programming' },
                            getLabel(`operationType${type}`),
                        getLabel('programmingNewPage')
                    ]
                }
            />
            {renderNavMenu()}
        </div>
        <div className="primary_container_bottom">
            {renderOperationCase()}
        </div>
    </div>)
}

export default OperationsForm